import Photo1 from './Images/1.webp'
import Photo2 from './Images/2.webp'
import Photo3 from './Images/3.webp'
import Photo4 from './Images/4.webp'
import Photo5 from './Images/5.webp'
import Photo6 from './Images/6.webp'
import Photo7 from './Images/7.webp'
import Photo8 from './Images/8.webp'
import Photo9 from './Images/9.webp'

const projects = [
    {
        name: "Events PCCOE",
        tech: [
            "React",
            "Firebase",
        ],
        links: {
            git: "",
            link: "https://eventspccoe.web.app/",
        },
        img: Photo1,
        date: "October 21"
    }, {
        name: "Graphics.h",
        tech: [
            "C",
            "Python",
        ],
        links: {
            git: "https://github.com/Ajinkyap331/Alternate_Of_Graphics.h",
            link: "",
        },
        img: Photo2,
        date: "September 21"
    }, {
        name: "Attendance App",
        tech: [
            "React Native",
            "Firebase",
        ],
        links: {
            git: "https://github.com/Ajinkyap331/InnerJourney",
            link: "",
        },
        img: Photo3,
        date: "October 21"
    }, {
        name: "My Classroom",
        tech: [
            "React",
            "Firebase",
        ],
        links: {
            git: "https://github.com/Ajinkyap331/Classroom-Clone",
            link: "https://ajinkyap331.github.io/Classroom-Clone/",
        },
        img: Photo4,
        date: "Ongoing"
    },
    {
        name: "Safe Resto",
        tech: [
            "Flutter",
            "Firebase",
        ],
        links: {
            git: "https://github.com/PranavMasekar/Safe-Restro",
            link: "",
        },
        img: Photo5,
        date: "November 2021"
    },
    {
        name: "Codechef PCCOE Chapter", 
        tech: [
            "React",
            "Firebase",
        ],
        links: {
            git: "https://github.com/Ajinkyap331/codechef-website",
            link: "https://codechefpccoe.web.app/",
        },
        img: Photo4,
        date: "Ongoing"
    },
]

const achivements = [
    {
        name: "Copyright",
        text: "I own a copyRight from the Government of India regarding an Idea to solve a Balanced Chemical Equation Using Python",
        date: "July 2021",
        photo: Photo6
    },
    {
        name: "Worked as a Coordinator",
        text: "Worked as a Coordinator at Tech-Fest 2K21 Held at PCCOE, Pune",
        date: "July 2021",
        photo: Photo7
    },
    {
        name: "Contributed in Open Source",
        text: "Working as a Contributor in GWOC'21",
        date: "December 2021",
        photo: Photo8
    },
    {
        name: "Team : CodeChef PCCOE Chapter",
        text: "Working as CP Team Member in CodeChef PCCOE Chapter",
        date: "July 2021",
        photo: Photo9
    },
    {
        name: "President of CodeChef <PCCOE> Chapter",
        text: "Working as President at Codechef <PCCOE> Chapter",
        date: "Till Present",
        photo: Photo9
    },
    {
        name: "Technical Head at GDSC PCCOE",
        text: "Working as Technical Head at GDSC PCCOE",
        date: "Till Present",
        photo: Photo9
    }
]

export { achivements, projects };